import React, { useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";

import LayerControl from "@/components/layer/LayerControl";
import { actionCreators as timelineActionCreators } from "@/duck/timeline";
import { actionCreators } from "@/duck/panel";
import { selectCurrentLayerGroup } from "@/selector";
import "@/components/layer/SeaLaneLayerControl.less";

const SeaLaneLayerControl = ({ layerGroup, toggleLayer }) => {
  const { t } = useTranslation();
  const currentLayerGroup = useSelector(selectCurrentLayerGroup);
  const groupName = "route";

  const dispatch = useDispatch();
  const settingLayer = useCallback(() => {
    dispatch(actionCreators.panel.temperature.reset());
    dispatch(
      timelineActionCreators.timeline.show({ currentLayerGroup: groupName })
    );
  }, [dispatch, groupName]);
  return (
    <LayerControl
      name={t("analysis.lane")}
      title="定量评估北极通航风险以及自动提取最优航道"
      groupName={groupName}
      isCurrent={currentLayerGroup === groupName}
      isShow={layerGroup.includes(groupName)}
      toggleLayer={toggleLayer}
      settingLayer={settingLayer}
    />
  );
};

export default SeaLaneLayerControl;
